import React, { FC } from 'react';

import styles from './_TopTenBadge.module.css';

interface TopTenBadgeProps {
    title: string;
}

export const TopTenBadge: FC<TopTenBadgeProps> = ({ title }) => (
    <div className={styles.root}>
        <div className={styles.icon} />
        <span>{title}</span>
    </div>
);
